angular.module("companies")

    .controller('CompaniesListCtrl', ['$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', 'uiGridConstants', '$filter', 'LoginService', '$state', function ($rootScope, $scope, Restangular, gridService, modalService, uiGridConstants, $filter, LoginService, $state) {

        if (!LoginService.permissionExist("P_MODIFY_USER_COMPANY"))
            $state.go("companies.edit", { id: LoginService.get("companyId") });

        $rootScope.title = $filter('translate')('companies.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('companies.list') }
        ];

       
        $scope.gridOptionsCompanies = {
            pdfTitle: $filter('translate')('companies.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            paginationPageSizes: [10, 20, 30],
            paginationPageSize: 10,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
              { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
              { name: 'name', displayName: $filter('translate')('companies.name'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
              { name: 'address', displayName: $filter('translate')('companies.address'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
              { name: 'phone_1', displayName: $filter('translate')('companies.phone_1'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
              { name: 'email', displayName: $filter('translate')('companies.email'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('companies.button_edit'), action: 'ui-sref="companies.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('companies.button_delete'), action: 'ng-click="grid.appScope.BorrarDialog(row.entity.id,row.entity.name);"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {
                return Restangular.all('Companies').getList(options);
            }
            
        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("companies.edit", { id: rowEntity.id });
        }

        $scope.BorrarDialog = function (id,name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('companies.button_delete'),
                message: $filter('translate')('companies.delete_message')+" "+ + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('Companies', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('companies.delete_success'));
                    $scope.gridOptionsCompanies.gridApi.core.raise.itemDeleted($scope);
                        
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };


    }])

;